import { render, staticRenderFns } from "./UiHtmlPage.vue?vue&type=template&id=e1a06606"
import script from "./UiHtmlPage.vue?vue&type=script&lang=js"
export * from "./UiHtmlPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports